import ApiService from "../api.services";
import GatewayService from "../gateway.services";

const PaymentService = {
    baseUrl: 'https://api.pagar.me/core/v5',
    add: async function (data) {
        try {
            const response = await ApiService.post('/api/payment', data);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    token: async function (data) {
        try {
            const response = await GatewayService.customRequest(`${this.baseUrl}/tokens?appId=${process.env.VUE_APP_PAGARME_APP}`, {
                method: "POST",
                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json",
                }
            });
            return await response.json();
        } catch (error) {
            throw error;
        }
    },
    pix: async function (data) {
        try {
            const response = await ApiService.post(`/api/payment/pix`, data);
            console.log('response', response)
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    card: async function (data) {
        try {
            const response = await ApiService.post(`/api/payment/card`, data);
            console.log('response', response)
            return response.data;
        } catch (error) {
            throw error;
        }
    },
};

export default PaymentService;

export { PaymentService };

